module.exports = __webpack_public_path__ + "static/media/med.cb399d01.svg";